import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row } from 'react-bootstrap';

const Globals = require('../../../../app/globals');
const SortUtil = require('../../util/SortUtil');
import TableHeaderSortIcon from '../table/TableHeaderSortIcon';

const propTypes = {
    className: PropTypes.string,
    sortObj: SortUtil.SortObjPropType.isRequired,
    sortFunc: PropTypes.func,
    contentType: PropTypes.oneOf([Globals.content_type.ACTIVITY, Globals.content_type.COURSE]).isRequired,
};

const defaultProps = {
    className: '',
    sortFunc: null
};

function ProjectListHeader({ className, sortObj, sortFunc, contentType }) {
    const sortIconElem =  <TableHeaderSortIcon className="margin-left-sm" asc={SortUtil.sortObjIsAsc(sortObj)} />;

    return (
        <Container fluid className={`projectListHeader listing--noBg overflow-x-hidden font-size-14px ${className}`}>
            <Row>
                <div className="col-3 col-sm-2 col-md-1" /> {/* filler column for ExpansionButtons */}
                <div className="col-7 col-sm-7 col-md-5 col-lg-3 nowrap">
                    { sortFunc ?
                        <span role="button" onClick={sortFunc.bind(null, 'name', Globals.sort.type.STRING)}>Name</span>
                        :
                        'Name'
                    }
                    { SortUtil.sortObjUsesKey(sortObj, 'name') && sortIconElem }
                </div>
                <div className="d-none d-sm-none d-md-block col-md-2 col-lg-2 nowrap">
                    { sortFunc ?
                        <span role="button" onClick={sortFunc.bind(null, 'created_at', Globals.sort.type.DATE)}>Created</span>
                        :
                        'Created'
                    }
                    { SortUtil.sortObjUsesKey(sortObj, 'created_at') && sortIconElem }
                </div>
                <div className="d-none d-sm-none d-md-block col-md-2 col-lg-2 nowrap">
                    { sortFunc ?
                        <span role="button" onClick={sortFunc.bind(null, 'modified', Globals.sort.type.DATE)}>Modified</span>
                        :
                        'Modified'
                    }
                    { SortUtil.sortObjUsesKey(sortObj, 'modified') && sortIconElem }
                </div>
                {(contentType === Globals.content_type.ACTIVITY) &&
                    <div className="col-2 col-sm-2 col-md-2 col-lg-1 text-right nowrap">
                        { sortFunc ?
                            <span role="button" onClick={sortFunc.bind(null, 'activity_count', Globals.sort.type.INT)}>Activities</span>
                            :
                            'Activities'
                        }
                        { SortUtil.sortObjUsesKey(sortObj, 'activity_count') && sortIconElem }
                    </div>
                }
                {(contentType === Globals.content_type.COURSE) &&
                    <div className="col-2 col-sm-2 col-md-2 col-lg-1 text-right nowrap">
                        { sortFunc ?
                            <span role="button" onClick={sortFunc.bind(null, 'short_course_count', Globals.sort.type.INT)}>Short Courses</span>
                            :
                            'Short Courses'
                        }
                        { SortUtil.sortObjUsesKey(sortObj, 'short_course_count') && sortIconElem }
                    </div>
                }
                {(contentType === Globals.content_type.ACTIVITY) &&
                    <div className="d-none d-sm-none d-md-none d-lg-block col-lg-1 text-right nowrap">
                        { sortFunc ?
                            <span role="button" onClick={sortFunc.bind(null, 'published_activity_count', Globals.sort.type.INT)}>Published Activities</span>
                            :
                            'Published Activities'
                        }
                        { SortUtil.sortObjUsesKey(sortObj, 'published_activity_count') && sortIconElem }
                    </div>
                }
                {(contentType === Globals.content_type.COURSE) &&
                    <div className="d-none d-sm-none d-md-none d-lg-block col-lg-1 text-right nowrap">
                        { sortFunc ?
                            <span role="button" onClick={sortFunc.bind(null, 'published_short_course_count', Globals.sort.type.INT)}>Published Short Courses</span>
                            :
                            'Published Short Courses'
                        }
                        { SortUtil.sortObjUsesKey(sortObj, 'published_short_course_count') && sortIconElem }
                    </div>
                }
                {/*
                <div className="d-none d-sm-none d-bd-block col-md-2 col-lg-2 text-right nowrap">
                    { sortFunc ?
                        <span role="button" onClick={sortFunc.bind(null, 'project_collaborator_count', Globals.sort.type.INT)}>Collaborators</span>
                        :
                        'Collaborators'
                    }
                    { SortUtil.sortObjUsesKey(sortObj, 'project_collaborator_count') && sortIconElem }
                </div>
            */}
            </Row>
        </Container>
    );
}

ProjectListHeader.propTypes = propTypes;
ProjectListHeader.defaultProps = defaultProps;

export default ProjectListHeader;
